var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-card-title",
                {
                  staticClass: "pt-0"
                },
                [_vm._v(" My Invoices ")]
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "py-0",
              attrs: {
                cols: "12"
              }
            },
            [_c("profile-navigation")],
            1
          ),
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-loading",
                {
                  attrs: {
                    loading: !_vm.invoices_loaded,
                    type: "table"
                  }
                },
                [
                  _c(
                    "gg-card",
                    [
                      _c(
                        "gg-card-text",
                        [
                          _c("v-data-table", {
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.invoices,
                              "footer-props": {
                                itemsPerPageOptions: this.paginationBilling
                              },
                              "sort-by": "id",
                              "sort-desc": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item.id",
                                fn: function fn(_ref) {
                                  var item = _ref.item
                                  return [
                                    _c("router-link", {
                                      attrs: {
                                        to: "/billing/".concat(item.id),
                                        custom: ""
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function fn(_ref2) {
                                              var navigate = _ref2.navigate
                                              return [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "ggs-item-title primary--text",
                                                    attrs: {
                                                      role: "link",
                                                      "aria-label":
                                                        "View Invoice"
                                                    },
                                                    on: {
                                                      click: navigate,
                                                      keypress: function keypress(
                                                        $event
                                                      ) {
                                                        if (
                                                          !$event.type.indexOf(
                                                            "key"
                                                          ) &&
                                                          _vm._k(
                                                            $event.keyCode,
                                                            "enter",
                                                            13,
                                                            $event.key,
                                                            "Enter"
                                                          )
                                                        ) {
                                                          return null
                                                        }
                                                        return navigate($event)
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " #" +
                                                        _vm._s(item.id) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ]
                                }
                              },
                              {
                                key: "item.total",
                                fn: function fn(_ref3) {
                                  var item = _ref3.item
                                  return [
                                    _vm._v(" $" + _vm._s(item.totall) + " ")
                                  ]
                                }
                              },
                              {
                                key: "item.status",
                                fn: function fn(_ref4) {
                                  var item = _ref4.item
                                  return [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "pb-1",
                                        attrs: {
                                          small: "",
                                          color: _vm.statusColor(item.status)
                                        }
                                      },
                                      [_vm._v("mdi-circle")]
                                    ),
                                    _vm._v(" " + _vm._s(item.status) + " ")
                                  ]
                                }
                              },
                              {
                                key: "item.date",
                                fn: function fn(_ref5) {
                                  var item = _ref5.item
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatRenewalDate(
                                            _vm.parseRenewalDate(item.date)
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                }
                              },
                              {
                                key: "item.duedate",
                                fn: function fn(_ref6) {
                                  var item = _ref6.item
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatRenewalDate(
                                            _vm.parseRenewalDate(item.duedate)
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                }
                              },
                              {
                                key: "item.actions",
                                fn: function fn(_ref7) {
                                  var item = _ref7.item
                                  return [
                                    _c(
                                      "gg-btn",
                                      {
                                        attrs: {
                                          color: "primary",
                                          to: "/billing/".concat(item.id)
                                        }
                                      },
                                      [
                                        _vm._v(" View Invoice "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "visually-hidden text-lowercase"
                                          },
                                          [_vm._v(" button ")]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("cancellations-list")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }